import css from 'styled-jsx/css'

import { colors } from '../../../theme'
import common from '../../../theme/common'


export default css`
  a {
    text-decoration: none;
  }

  p {
    ${common.text};

    color: ${colors.pureWhite};
    font-family: 'Open Sans Regular', sans-serif;
    font-size: 1.6rem;
    font-weight: 700;
  }
`
